import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationComponent } from '@rentigo/ngx-authorization';
import { LayoutComponent } from './shared/layout/layout.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./welcome/welcome.module').then(x => x.WelcomeModule)
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'security-deposit',
        loadChildren: () => import('./security-deposit/security-deposit.module').then(x => x.SecurityDepositModule)
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'auth/callback',
    component: AuthenticationComponent
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
